import { React } from 'react'
import { colors } from 'globalStyles'
import SVGIcon from 'reusableComponents/SVGIcon'
import PropTypes from 'prop-types'
import {
  tableHeaderStyle,
  tableContentStyle,
  tableSubContentStyle,
  styledDiv,
} from './PackageDeliveryPreferences.style'

const PackageDeliveryPreferencesView = ({ icon, label, value, iconStyle }) => (
  <div style={styledDiv}>
    <div style={tableHeaderStyle}>
      <SVGIcon
        Icon={icon}
        size="lg"
        color={colors.secondary_light_blue}
        aria-label={label}
        style={iconStyle}
      />
    </div>
    <div style={{ display: 'table-cell' }}>
      <div style={tableContentStyle}>{label}:</div>
      <div style={tableSubContentStyle}>{value}</div>
    </div>
  </div>
)

PackageDeliveryPreferencesView.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  icon: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  iconStyle: PropTypes.object.isRequired,
}

export default PackageDeliveryPreferencesView
